module.exports = __webpack_public_path__ + "img/notNotice.7678abfb.png";